import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import { RenderIf } from '../../components/utils/RenderIf';
import { Button } from 'react-bootstrap'
import { Card } from 'react-bootstrap';
import { DivicesFechtAPI } from '../../api/Divices';
import { WhatsappFetchAPI } from '../../api/Whatsapp';
import { MachinesFetchAPI } from '../../api/Machines';
import VendingModalKeyCode from './VendingModalKeyCode';
import img_dispensed from './img/delivery.gif'
import img_Error from './img/error.gif'
import imp_yappy from './img/yappy.png'


import Swal from 'sweetalert2';

function VendingModalYappy({ showModalYappy, setShowModalYappy, selectPaymentYappy, paymentValidYappy }) {
    let token = localStorage.getItem('x-access-token');
    let machine = localStorage.getItem('machine_vending')
    let business = localStorage.getItem('business_vending')
    let branchoffice = localStorage.getItem('branchoffice_vending')


    const [stringType, setStringType] = useState("")
    const [eventHandlerKey, setEventHandlerKey] = useState(0)
    const buttons_key = [
        "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"
    ];

    const sumString = (key) => {

        let newString = stringType + key
        console.log(newString);
        setStringType(newString)
        setEventHandlerKey(1)
    }


    const handlerYappy = (e) => {
        setStringType("")

        paymentValidYappy(e, selectPaymentYappy, stringType)
        setShowModalYappy(false)


    }



    //Hook to load the initial info
    useEffect(() => {
        setEventHandlerKey(0)
    }, [eventHandlerKey]);

    return (
        <>
            {/*showModalYappy  */}
            <Modal
                show={showModalYappy}
                size='lg'
                centered
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Body>
                    <div className="vmy-root">

                        {/* Halo morado (color de Yappy) */}
                        <div className="vmy-halo" />

                        {/* ========== HEADER ========== */}
                        <header className="vmy-header">
                            <div className="vmy-header-media">
                                <div className="vmy-header-ring" />
                                <div className="vmy-header-ring vmy-header-ring-2" />
                                <img
                                    className="vmy-header-img"
                                    src={imp_yappy}
                                    alt="Yappy"
                                />
                            </div>

                            <h2 className="vmy-title">
                                Ingresa tu número
                                <br />
                                <em>de Yappy, por favor</em>
                            </h2>

                            <div className="vmy-info-card">
                                <i className="uil uil-mobile-android-alt"></i>
                                <p>Te enviaremos una solicitud de pago a tu app de Yappy</p>
                            </div>
                        </header>

                        {/* ========== CENTRO: display + keypad ========== */}
                        <main className="vmy-main">

                            {/* Display del número */}
                            <div className="vmy-display">
                                <span className="vmy-display-label">
                                    <i className="uil uil-phone-alt"></i>
                                    Tu número
                                </span>
                                <div className="vmy-display-value">
                                    {stringType == "" ? "6000-0000" : stringType}
                                </div>
                            </div>

                            {/* Keypad: 3 cols × 4 filas. Última fila = 0 + Borrar (span 2) */}
                            <div className="vmy-keypad">
                                {buttons_key.map((button, idx) => {
                                    const isZero = button === "0" || idx === 9;
                                    return (
                                        <button
                                            key={`k-${button}-${idx}`}
                                            className={`vmy-key vmy-key-num ${isZero ? 'vmy-key-zero' : ''}`}
                                            onClick={() => sumString(button)}
                                        >
                                            {button}
                                        </button>
                                    );
                                })}

                                {/* Borrar ocupa 2 columnas */}
                                <button
                                    className="vmy-key vmy-key-clear"
                                    onClick={() => (setStringType(""), setEventHandlerKey(1))}
                                >
                                    <i className="uil uil-backspace"></i>
                                    <span>Borrar</span>
                                </button>
                            </div>
                        </main>

                        {/* ========== FOOTER ========== */}
                        <footer className="vmy-footer">
                            <button
                                className="vmy-btn vmy-btn-close"
                                onClick={() => (setShowModalYappy(false), setStringType(""))}
                            >
                                <i className="uil uil-times-circle"></i>
                                <span>Cerrar</span>
                            </button>

                            <button
                                className="vmy-btn vmy-btn-send"
                                onClick={(e) => (handlerYappy(e))}
                                disabled={!stringType || stringType.length === 0}
                            >
                                <i className="uil uil-message"></i>
                                <span>Enviar</span>
                            </button>
                        </footer>
                    </div>
                </Modal.Body>
            </Modal>


        </>
    )
}

export default VendingModalYappy